import React, { useEffect, useState } from "react";

import moment from "moment";
import axios from "axios";

import AllowLeft from "../../assets/icons/arrowLeftGray.svg";
import Calendar from "../../assets/icons/biCalendar.svg";
import APIVariables from "../../services/api-variables";

import { registrationCategory } from "../../constants/register.constants";
import { errorMessages } from "../../constants/errorMessages.constants";

import HealthcareProfessionalInformationGuide from "./../pages/PatientMaterial/Brochures/PDFs/HealthcareProfessionalInformationGuide.pdf";
import { AsyncPaginate } from "react-select-async-paginate";

const RegisterForm = ({
  stateRegister,
  previous,
  handleChange,
  registerForm,
  isSubmitting,
  handleChangeCheckBox,
  formFields,
  handleChangeSelect,
  typeOfForm,
  errorMessage,
  setWasLinkClicked,
}) => {
  const invalidEmail = (errorMessage || []).find((element) =>
    element.includes("email")
  );

  const invalidRegistrationNumber = (errorMessage || []).find((element) =>
    element.includes("registration_number")
  );

  const invalidPhoneNumber = (errorMessage || []).find((element) =>
    element.includes("phone_number")
  );

  const invalidPassword = (errorMessage || []).find((element) =>
    element.includes("password")
  );

  const [nextURL, setNextPage] = useState(false);

  useEffect(() => {
    // Reset the AsyncPaginate dropdown to start from initial call
    setNextPage(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateRegister]);

  const isValidRegistrationFromFE =
    registerForm?.registration_number?.trim().length > 0 &&
    registerForm?.registration_number?.trim().length <= 20 &&
    isSubmitting;

  const isUndefinedRegistratioNumberFE =
    registerForm.registration_number === undefined && isSubmitting;

  const isNotRegistrationNumberTyped =
    isSubmitting &&
    !formFields.registration_number?.isValid &&
    (registerForm.registration_number?.length === 0 ||
      registerForm.registration_number === undefined);

  const isRegistrationNumberExceeded =
    isSubmitting &&
    !formFields.registration_number?.isValid &&
    registerForm?.registration_number?.length > 12;

  const validateRegistrationNumber = () => {
    if (!isValidRegistrationFromFE || isUndefinedRegistratioNumberFE) {
      if (isNotRegistrationNumberTyped) {
        return <span className="required-text">Required</span>;
      } else if (isRegistrationNumberExceeded) {
        return (
          <span className="required-text">Registration Number too long</span>
        );
      } else if (invalidRegistrationNumber?.length) {
        return (
          <span className="required-text">
            {invalidRegistrationNumber?.split("-")[1]}
          </span>
        );
      } else {
        <span className="required-text"></span>;
      }
    } else {
      return <span></span>;
    }
  };

  const updateParamsIntoAPI_URL = (search, propertyName) => {
    const fullURL = new URL(nextURL);
    const baseUrl = `${fullURL.origin}${fullURL.pathname}`;

    let urlParams = new URLSearchParams(window.location.search);
    const pageNumber = new URLSearchParams(nextURL.split("?")[1]).get("page");

    urlParams.set(propertyName, search);
    urlParams.set("page", pageNumber);

    let url = `${baseUrl}?${urlParams.toString()}`;
    return url;
  };

  async function loadOptionsPharmacy(search) {
    const baseURLCall =
      process.env.REACT_APP_BASE_URL +
      APIVariables.HCP_PHARMACY +
      "?pharmacy_name=" +
      (search || "");

    const apiURL = nextURL
      ? updateParamsIntoAPI_URL(search, "pharmacy_name")
      : baseURLCall;

    const getPharmacyOptions = await axios.get(apiURL).catch(() => {
      setNextPage(false);
    });

    if (getPharmacyOptions.status === 200) {
      const responseJSON = getPharmacyOptions.data;

      const finalData = responseJSON.results.map((element) => {
        return {
          value: element.id,
          label: element.pharmacy_name,
          address: element.address,
          delivery_address: element.delivery_address,
          ordering_address: element.ordering_address,
        };
      });

      let hasMore;
      if (!!responseJSON.next) {
        const url = responseJSON.next;
        const urlParams = new URLSearchParams(url.split("?")[1]);
        const page = urlParams.get("page");
        hasMore = !!page;
      } else {
        hasMore = false;
      }

      if (hasMore) {
        setNextPage(responseJSON.next);
      }

      return {
        options: finalData,
        hasMore: hasMore,
      };
    }
  }

  const loadOptionsHospitals = async (search) => {
    const baseURLCall =
      process.env.REACT_APP_BASE_URL +
      APIVariables.HCP_HOSPITALS +
      "?hospital_name=" +
      (search || "");

    const apiURL = nextURL
      ? updateParamsIntoAPI_URL(search, "hospital_name")
      : baseURLCall;

    const getHospitalOptions = await axios.get(apiURL).catch(() => {
      setNextPage(false);
    });

    if (getHospitalOptions.status === 200) {
      const responseJSON = getHospitalOptions.data;

      const finalData = responseJSON.results.map((element) => {
        return {
          value: element.id,
          label: element.hospital_name,
          address: element.address,
        };
      });

      let hasMore;
      if (!!responseJSON.next) {
        const url = responseJSON.next;
        const urlParams = new URLSearchParams(url.split("?")[1]);
        const page = urlParams.get("page");
        hasMore = !!page;
      } else {
        hasMore = false;
      }

      if (hasMore) {
        setNextPage(responseJSON.next);
      }

      return {
        options: finalData,
        hasMore: hasMore,
      };
    }
  };

  return (
    <React.Fragment>
      {stateRegister === 2 && (
        <React.Fragment>
          <h1 className="select-category-txt">
            {typeOfForm === registrationCategory.PRESCRIBER_PHYSICIAN
              ? "Prescribing Physician Registration Form"
              : "Pharmacy Registration Form"}
          </h1>

          <hr className="green-hr" />

          <div className="group-back">
            <button className="back" onClick={previous}>
              <img src={AllowLeft} alt="Arrow left" />
            </button>
            <div>
              {typeOfForm === registrationCategory.PRESCRIBER_PHYSICIAN
                ? "Prescribing Physician Registration Form"
                : "Pharmacy Registration Form"}
            </div>
          </div>
          <div className="wrapper-brackground">
            <h2 className="title-details">
              {typeOfForm === registrationCategory.PRESCRIBER_PHYSICIAN
                ? "Physician Details"
                : "Pharmacy Details"}
            </h2>
            <div className="container">
              <div className="row">
                <div className="col">
                  <label
                    className={
                      isSubmitting && !formFields.first_name.isValid
                        ? "red-label"
                        : ""
                    }
                  >
                    {typeOfForm === registrationCategory.PRESCRIBER_PHYSICIAN
                      ? "Physician First Name:*"
                      : "Chief/ Superintendent Pharmacist (or appointed deputy) First Name:*"}
                  </label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="first_name"
                    value={registerForm.first_name}
                    maxLength={30}
                    className={
                      isSubmitting && !formFields.first_name.isValid
                        ? "error"
                        : ""
                    }
                  />
                  {isSubmitting && !formFields.first_name?.isValid && (
                    <span className="required-text">Required</span>
                  )}
                </div>
                <div className="col">
                  <label
                    className={
                      isSubmitting && !formFields.last_name.isValid
                        ? "red-label"
                        : ""
                    }
                  >
                    {typeOfForm === registrationCategory.PRESCRIBER_PHYSICIAN
                      ? "Physician Last Name:*"
                      : "Chief/ Superintendent Pharmacist (or appointed deputy) Last Name:*"}
                  </label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="last_name"
                    maxLength={30}
                    value={registerForm.last_name}
                    className={
                      isSubmitting && !formFields.last_name.isValid
                        ? "error"
                        : ""
                    }
                  />
                  {isSubmitting && !formFields.last_name?.isValid && (
                    <span className="required-text">Required</span>
                  )}
                </div>
              </div>
              {typeOfForm.includes(registrationCategory.PRESCRIBER) && (
                <div className="row">
                  <div className="col">
                    <label
                      className={
                        isSubmitting && !formFields.registration_number.isValid
                          ? "red-label"
                          : ""
                      }
                    >
                      Medical Council Number:*
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="registration_number"
                      maxLength={12}
                      value={registerForm.registration_number}
                      className={
                        isSubmitting && !formFields.registration_number.isValid
                          ? "error"
                          : ""
                      }
                    />
                    <React.Fragment>
                      {validateRegistrationNumber()}
                    </React.Fragment>
                  </div>
                  <div className="col">
                    <label
                      className={
                        isSubmitting && !formFields.job_title.isValid
                          ? "red-label"
                          : ""
                      }
                    >
                      Job Title:*
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="job_title"
                      maxLength={30}
                      value={registerForm.job_title}
                      className={
                        isSubmitting && !formFields.job_title.isValid
                          ? "error"
                          : ""
                      }
                    />
                    {isSubmitting && !formFields.job_title?.isValid && (
                      <span className="required-text">Required</span>
                    )}
                  </div>
                </div>
              )}
              {typeOfForm === registrationCategory.PHARMACY && (
                <div className="row">
                  <div className="col">
                    <label
                      className={
                        isSubmitting && !formFields.registration_number.isValid
                          ? "red-label"
                          : ""
                      }
                    >
                      Pharmacy GMS Number:*
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="registration_number"
                      maxLength={20}
                      value={registerForm.registration_number}
                      className={
                        isSubmitting && !formFields.registration_number.isValid
                          ? "error"
                          : ""
                      }
                    />
                    <React.Fragment>
                      {validateRegistrationNumber()}
                    </React.Fragment>
                  </div>
                  <div className="col custom-select-register">
                    <label
                      className={
                        isSubmitting && !formFields.pharmacy_id.isValid
                          ? "red-label"
                          : ""
                      }
                    >
                      Pharmacy Name:*
                    </label>
                    <AsyncPaginate
                      debounceTimeout={300}
                      loadOptions={loadOptionsPharmacy}
                      onChange={(selectedOption) => {
                        handleChangeSelect(selectedOption, "pharmacy_id");
                      }}
                      className={
                        "optimization-dropdown " +
                        (isSubmitting && !formFields.pharmacy_id.isValid
                          ? "error-select"
                          : "select-border")
                      }
                      value={registerForm.pharmacy_id}
                    />
                    {isSubmitting && !formFields.pharmacy_id?.isValid && (
                      <span className="required-text">Required</span>
                    )}
                  </div>
                </div>
              )}
              {typeOfForm.includes(registrationCategory.PHARMACY) && (
                <div className="row">
                  <div className="col">
                    <label
                      className={
                        (isSubmitting && !formFields.phone_number?.isValid) ||
                        (isSubmitting &&
                          !formFields?.phone_number_validate?.isValid) ||
                        invalidPhoneNumber?.length
                          ? "red-label"
                          : ""
                      }
                    >
                      Pharmacy Contact Number:*
                    </label>
                    <input
                      onChange={handleChange}
                      name="phone_number"
                      value={registerForm.phone_number}
                      maxLength={13}
                      type="text"
                      className={
                        (isSubmitting && !formFields.phone_number?.isValid) ||
                        (isSubmitting &&
                          !formFields?.phone_number_validate?.isValid) ||
                        invalidPhoneNumber?.length
                          ? "error"
                          : ""
                      }
                    />
                    {isSubmitting && !formFields.phone_number?.isValid ? (
                      <span className="required-text">Required</span>
                    ) : isSubmitting &&
                      !formFields?.phone_number_validate?.isValid ? (
                      <span className="required-text">
                        Invalid Phone Number
                      </span>
                    ) : invalidPhoneNumber?.length ? (
                      <span className="required-text">
                        {invalidPhoneNumber?.split("-")[1]}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col"></div>
                </div>
              )}

              <div className="row">
                {typeOfForm.includes(registrationCategory.PRESCRIBER) && (
                  <div className="col custom-select-register">
                    <label
                      className={
                        isSubmitting && !formFields.hospital_id.isValid
                          ? "red-label"
                          : ""
                      }
                    >
                      Hospital Name:*
                    </label>
                    <AsyncPaginate
                      debounceTimeout={300}
                      loadOptions={loadOptionsHospitals}
                      onChange={(selectedOption) => {
                        handleChangeSelect(selectedOption, "hospital_id");
                      }}
                      className={
                        "optimization-dropdown optimization-dropdown-align-fix " +
                        (isSubmitting && !formFields.hospital_id.isValid
                          ? "error-select"
                          : "select-border")
                      }
                      value={registerForm.hospital_id}
                    />
                    {isSubmitting && !formFields.hospital_id?.isValid && (
                      <span className="required-text">Required</span>
                    )}
                  </div>
                )}

                <div className="col"></div>
              </div>
              {typeOfForm !== registrationCategory.PHARMACY && (
                <div className="row">
                  <div className="col">
                    <label
                      className={
                        isSubmitting && !formFields.hospital_id.isValid
                          ? "red-label"
                          : ""
                      }
                    >
                      Hospital Address:*
                    </label>
                    <input
                      type="text"
                      name="hospital_address"
                      value={registerForm?.hospital_id?.address}
                      disabled
                    />
                  </div>
                </div>
              )}
              {typeOfForm === registrationCategory.PHARMACY && (
                <div className="row">
                  <div className="col">
                    <label
                      className={
                        isSubmitting && !formFields.pharmacy_id.isValid
                          ? "red-label"
                          : ""
                      }
                    >
                      Dispensing Pharmacy Address:*
                    </label>
                    <input
                      type="text"
                      name="address1"
                      maxLength={12}
                      value={registerForm?.pharmacy_id?.address}
                      disabled
                    />
                  </div>
                </div>
              )}
              {typeOfForm === registrationCategory.PHARMACY && (
                <div className="row">
                  <div className="col">
                    <label>Delivery Address (if different):</label>
                    <input
                      type="text"
                      name="delivery_address"
                      maxLength={75}
                      value={registerForm.delivery_address}
                      onChange={handleChange}
                      placeholder="Only complete if different to the address listed above"
                    />
                  </div>
                </div>
              )}
              {typeOfForm === registrationCategory.PHARMACY && (
                <div className="row">
                  <div className="col">
                    <label>
                      Ordering Address (If different to delivery address):
                    </label>
                    <input
                      type="text"
                      name="ordering_address"
                      maxLength={75}
                      value={registerForm.ordering_address}
                      onChange={handleChange}
                      placeholder="Only complete if different to the address listed above"
                    />
                  </div>
                </div>
              )}
            </div>

            <h2 className="title-details">Account Details</h2>

            <div className="container">
              <div className="row">
                <div className="col">
                  <label
                    className={
                      (isSubmitting && !formFields.email.isValid) ||
                      (isSubmitting &&
                        !formFields.emailValid.isValid &&
                        formFields.email.isValid)
                        ? "red-label"
                        : ""
                    }
                  >
                    Email Address:{" "}
                    {typeOfForm === registrationCategory.PHARMACY
                      ? "(A link will be sent to verify your email address, please use your Healthmail email)*"
                      : "(A link will be sent to verify your email address)*"}
                  </label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="email"
                    value={registerForm.email}
                    maxLength={75}
                    className={
                      (isSubmitting && !formFields.email.isValid) ||
                      (isSubmitting &&
                        !formFields.emailValid.isValid &&
                        formFields.email.isValid)
                        ? "error"
                        : ""
                    }
                  />
                  {isSubmitting && !formFields.email.isValid && (
                    <span className="required-text">Required</span>
                  )}
                  {isSubmitting &&
                    !formFields.emailValid.isValid &&
                    formFields.email.isValid && (
                      <span className="required-text">Invalid Email</span>
                    )}
                  {invalidEmail?.length && (
                    <span className="required-text">
                      {invalidEmail?.split("-")[1]}
                    </span>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <label
                    className={
                      isSubmitting && !formFields.password1.isValid
                        ? "red-label"
                        : ""
                    }
                  >
                    Create Password:*
                  </label>
                  <input
                    type="password"
                    onChange={handleChange}
                    name="password1"
                    value={registerForm.password1}
                    maxLength={64}
                    className={
                      isSubmitting && !formFields.password1.isValid
                        ? "error"
                        : ""
                    }
                  />
                  {isSubmitting && !formFields.password1?.isValid ? (
                    <p className="required-text-password">
                      <p>Minimum length of 8 characters</p>
                      <p> Minimum of 1 uppercase letter.</p>
                      <p> At least 1 non-alphanumeric character (~!@#$%)</p>
                      <p>At least 1 number</p>
                    </p>
                  ) : isSubmitting && !formFields.passwordMatch?.isValid ? (
                    <span className="required-text">
                      {errorMessages.PASSWORD_NOT_MATCH}
                    </span>
                  ) : invalidPassword?.length ? (
                    <span className="required-text">
                      {invalidPassword.split("-")[1]}
                    </span>
                  ) : (
                    <span></span>
                  )}
                </div>
                <div className="col">
                  <label
                    className={
                      isSubmitting && !formFields.password2.isValid
                        ? "red-label"
                        : ""
                    }
                  >
                    Confirm Password:*
                  </label>
                  <input
                    type="password"
                    onChange={handleChange}
                    name="password2"
                    value={registerForm.password2}
                    maxLength={64}
                    className={
                      isSubmitting && !formFields.password2.isValid
                        ? "error"
                        : ""
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}

      <React.Fragment>
        {stateRegister === 3 && typeOfForm === registrationCategory.PHARMACY && (
          <React.Fragment>
            <h1 className="select-category-txt">Pharmacy Registration Form</h1>

            <hr className="green-hr" />

            <div className="confirm">
              On behalf of {registerForm.pharmacy_id.label}, I agree to
              implement the following risk minimisation procedures when dealing
              with prescriptions for lenalidomide as specified by Accord
              Healthcare Ireland Ltd, Clonmel Healthcare Ltd, Mylan Ireland
              Limited or Teva Pharmaceuticals Ireland Ltd in the{" "}
              <a
                rel="noreferrer"
                href={HealthcareProfessionalInformationGuide}
                target="_blank"
                onMouseDown={(event) => {
                  if (event.button === 1 || event.button === 0) {
                    setWasLinkClicked(true);

                    event.preventDefault();
                  }
                }}
              >
                Lenalidomide Healthcare Professional Information Guide
              </a>
            </div>

            {typeOfForm === registrationCategory.PHARMACY && (
              <React.Fragment>
                <div className="prescriber-confirmation">
                  <label
                    htmlFor="confirmation_terms"
                    className="custom-checkbox"
                  >
                    1. I have read and understood the{" "}
                    <a
                      rel="noreferrer"
                      href={HealthcareProfessionalInformationGuide}
                      target="_blank"
                      onMouseDown={(event) => {
                        if (event.button === 1 || event.button === 0) {
                          setWasLinkClicked(true);

                          event.preventDefault();
                        }
                      }}
                    >
                      Lenalidomide Healthcare Professional Information Guide.*
                    </a>
                    <input
                      type="checkbox"
                      id="confirmation_terms"
                      name="confirmation_terms"
                      checked={registerForm.confirmation_terms}
                      onChange={handleChangeCheckBox}
                    />
                    <span className="checkmark" />
                  </label>
                  <label
                    htmlFor="confirmation_reqs_compliance"
                    className="custom-checkbox"
                  >
                    2. All pharmacists who dispense Lenalidomide will have read
                    and understood the{" "}
                    <a
                      rel="noreferrer"
                      href={HealthcareProfessionalInformationGuide}
                      target="_blank"
                      onMouseDown={(event) => {
                        if (event.button === 1 || event.button === 0) {
                          setWasLinkClicked(true);

                          event.preventDefault();
                        }
                      }}
                    >
                      Lenalidomide Healthcare Professional Information Guide.*
                    </a>
                    <input
                      type="checkbox"
                      id="confirmation_reqs_compliance"
                      name="confirmation_reqs_compliance"
                      checked={registerForm.confirmation_reqs_compliance}
                      onChange={handleChangeCheckBox}
                    />
                    <span className="checkmark" />
                  </label>

                  <label
                    htmlFor="confirmation_auth"
                    className="custom-checkbox"
                  >
                    3. If supplied with Lenalidomide, it will only be used for
                    the purpose of dispensing the product by the Pregnancy
                    Prevention Programme registered pharmacy to the patient.*
                    <input
                      type="checkbox"
                      id="confirmation_auth"
                      name="confirmation_auth"
                      checked={registerForm.confirmation_auth}
                      onChange={handleChangeCheckBox}
                    />
                    <span className="checkmark" />
                  </label>

                  <label
                    htmlFor="confirmation_supervised"
                    className="custom-checkbox"
                  >
                    4. Prescriptions for Lenalidomide will be dispensed only if
                    accompanied by a completed Prescription Authorization Form.*
                    <input
                      type="checkbox"
                      id="confirmation_supervised"
                      name="confirmation_supervised"
                      checked={registerForm.confirmation_supervised}
                      onChange={handleChangeCheckBox}
                    />
                    <span className="checkmark" />
                  </label>

                  <label
                    htmlFor="confirmation_aged_verification"
                    className="custom-checkbox"
                  >
                    5. The pharmacist dispensing Lenalidomide will check each
                    prescription and Prescription Authorization Form for
                    completeness and approve the authorisation form prior to
                    dispensing.*
                    <input
                      type="checkbox"
                      id="confirmation_aged_verification"
                      name="confirmation_aged_verification"
                      checked={registerForm.confirmation_aged_verification}
                      onChange={handleChangeCheckBox}
                    />
                    <span className="checkmark" />
                  </label>

                  <label
                    htmlFor="confirmation_other"
                    className="custom-checkbox"
                  >
                    6. Lenalidomide will be dispensed, checked and stored
                    according to our standard documented procedures for oral
                    anti-cancer medicines.*
                    <input
                      type="checkbox"
                      id="confirmation_other"
                      name="confirmation_other"
                      checked={registerForm.confirmation_other}
                      onChange={handleChangeCheckBox}
                    />
                    <span className="checkmark" />
                  </label>

                  <label
                    htmlFor="confirmation_other1"
                    className="custom-checkbox"
                  >
                    7. Dispensing will be limited to no more than a 4 week
                    supply for women of childbearing potential, and 12 weeks for
                    males and women of non-childbearing potential.*
                    <input
                      type="checkbox"
                      id="confirmation_other1"
                      name="confirmation_other1"
                      checked={registerForm.confirmation_other1}
                      onChange={handleChangeCheckBox}
                    />
                    <span className="checkmark" />
                  </label>

                  <label
                    htmlFor="confirmation_other2"
                    className="custom-checkbox"
                  >
                    8. Dispensing of Lenalidomide to women of childbearing
                    potential should occur within 7 days of the prescription.*
                    <input
                      type="checkbox"
                      id="confirmation_other2"
                      name="confirmation_other2"
                      checked={registerForm.confirmation_other2}
                      onChange={handleChangeCheckBox}
                    />
                    <span className="checkmark" />
                  </label>

                  <label
                    htmlFor="confirmation_other3"
                    className="custom-checkbox"
                  >
                    9. I will update my contact details in the
                    patientsafetyhub.ie in the event of any changes.*
                    <input
                      type="checkbox"
                      id="confirmation_other3"
                      name="confirmation_other3"
                      checked={registerForm.confirmation_other3}
                      onChange={handleChangeCheckBox}
                    />
                    <span className="checkmark" />
                  </label>
                </div>
                <div className="confirm">
                  By clicking ‘Register’, I understand that registration to
                  obtain and supply lenalidomide will only be granted if I agree
                  to items 1–9 described above as supply of lenalidomide without
                  participation in the required risk minimisation for pregnancy
                  prevention is contrary to the conditions of the marketing
                  authorisation. Registration is valid for 2 years at which
                  point I will confirm that we are continuing to follow the risk
                  minimisation procedures by completing this form.
                </div>
              </React.Fragment>
            )}

            <div className="container sign">
              <div className="row">
                <div className="col">
                  <label>Pharmacist Name*</label>
                  <input
                    type="text"
                    className="inputNameDate"
                    name="pharmacistName"
                    value={
                      registerForm.first_name + " " + registerForm.last_name
                    }
                    disabled
                  />
                </div>
                <div className="col">
                  <label>Date:*</label>
                  <input
                    className="transparent-background inputNameDate"
                    value={moment().format("DD / MM / YYYY")}
                    disabled
                  />
                  <img src={Calendar} alt="Calendar" className="calendar" />
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    </React.Fragment>
  );
};
export default RegisterForm;
